// Thin analytics helper. Pushes typed events to window.dataLayer.
// Works with GTM/GA4 when REACT_APP_GTM_ID is configured; no-op otherwise.
//
// Never send PII: e-mail, phone, CPF, full name, or private AI content.

export const EV = {
  BUSINESS_VIEW: "business_view",
  NEWS_VIEW: "news_view",
  LISTING_VIEW: "listing_view",
  PROPERTY_VIEW: "property_view",
  DOCTOR_VIEW: "doctor_view",
  VEHICLE_VIEW: "vehicle_view",
  INTERNAL_SEARCH: "internal_search",
  ASK_AI: "ask_ai",
  WHATSAPP_CLICK: "whatsapp_click",
  SHARE_CLICK: "share_click",
  FAVORITE: "favorite",
  LEAD_CLICK: "lead_click",
  CHECKOUT_START: "checkout_start",
  PURCHASE_COMPLETE: "purchase_complete",
};

const PII_KEYS = ["email", "phone", "cpf", "name", "full_name", "password", "token", "message"];

function sanitize(data) {
  const out = {};
  Object.entries(data || {}).forEach(([k, v]) => {
    if (PII_KEYS.includes(k)) return;
    if (typeof v === "string" && v.length > 200) v = v.slice(0, 200);
    out[k] = v;
  });
  return out;
}

export function trackEvent(event, data = {}) {
  try {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event, ...sanitize(data) });
  } catch (e) {
    console.debug("analytics.trackEvent failed:", e?.message || e);
  }
}

// Fire-and-forget search-log to backend. `results_count` optional.
// Called after a real search submit (not per keystroke).
export function logInternalSearch({ query, source = "other", category, results_count = 0 }) {
  if (!query || query.trim().length < 2) return;
  trackEvent(EV.INTERNAL_SEARCH, { search_term: query.slice(0, 100), search_source: source, category });
  // Best effort — this backend endpoint is public and lightweight.
  try {
    const base = process.env.REACT_APP_BACKEND_URL || "";
    fetch(`${base}/api/search/log`, {
      method: "POST", headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ query, source, category, results_count }),
      keepalive: true,
    }).catch((e) => console.debug("search/log failed:", e?.message || e));
  } catch (e) {
    console.debug("logInternalSearch failed:", e?.message || e);
  }
}
